<template>
    <router-view />
</template>

<style lang="scss">
body {
    margin: 0;
    padding: 0;
}
*,
::after,
::before {
    box-sizing: border-box;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
}
.container {
    max-width: 800px;
    margin: 0 auto;
    width: 100%;
}
h1,
h2,
h3,
h4,
p,
input {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
